import { Trans } from '@lingui/react/macro';
import Notification from '../Notification';

/**
 * Shown when the FIRST embed-token fetch for a dashboard fails.
 *
 * That fetch is deliberately not retried: it happens while the user is watching the page load, so a
 * reload is the honest remedy and we say so. (Refreshes the embed SDK makes later ARE retried - see
 * `fetchTokenWithRetry` in `./Dashboard` - because nobody is watching when those fail.) The backend's
 * reason stays underneath: a reload will not fix a missing grant, and the reason is what tells the two
 * apart.
 *
 * Kept in its own module so the lazily-loaded `SupersetDashboardField` can show it without pulling
 * the embed SDK into its chunk.
 *
 * @param {{ reason?: Error | string }} props
 */
function DashboardLoadFailed({ reason }) {
  const detail = reason instanceof Error ? reason.message : reason;

  return (
    <Notification color="danger">
      <h5 className="mb-1">
        <Trans>This dashboard could not be loaded. Refresh the page to try again.</Trans>
      </h5>
      {detail ? <p className="mb-2 small">{detail}</p> : null}
      <button className="btn btn-danger btn-sm" type="button" onClick={() => window.location.reload()}>
        <Trans>Reload page</Trans>
      </button>
    </Notification>
  );
}

export default DashboardLoadFailed;
